import { AppSetting } from 'dependencies/appsettings';

const webPushConfiguration = (AppSetting && AppSetting.WebPush) || {};
export const { firebaseConfig = {}, webPushCertificate = {} } = webPushConfiguration as any;
